import { create } from 'zustand';
import ServiceEmpregadores from '@/services/ServiceEmpregadores';
import { notify } from '@/stores/useToast';

type Empregador = any;

// Normaliza a company da view (/agnes/companies) p/ o contrato que as telas de encargos
// usam (company/socialName/fantasyName/cnpjFilial/cnpjMatriz), herdado do domínio antigo.

const normalizar = (e: any): Empregador => ({
  id: e.id,
  cnpjFilial: e.cnpj,
  cnpjMatriz: e.nrinsc, // raiz 8 dígitos
  company: e.razaoSocial,
  socialName: e.razaoSocial,
  fantasyName: e.nomeFantasia,
  city: e.municipio,
  stateCode: e.uf,
  // Certificado digital por empresa ("RAZÃO:CNPJ"), setado manualmente via tenant-provider.
  // Alimenta o header certificate-name das coletas e-CAC (sem cert fixo hardcoded).
  certificado: e.certificateName ?? '',
});

interface State {
  lista: Empregador[];
  carregando: boolean;
  carregado: boolean;
  erro: string | null;
  buscar: () => Promise<void>;
  reset: () => void;
}

let requestId = 0;

export const useEmpregadoresStore = create<State>((set) => ({
  lista: [],
  carregando: false,
  carregado: false,
  erro: null,
  async buscar() {
    const request = ++requestId;
    set({ lista: [], carregando: true, carregado: false, erro: null });
    try {
      const { data } = await ServiceEmpregadores.listar();
      const arr = Array.isArray(data) ? data : (data.content ?? []);
      if (request === requestId) set({ lista: arr.map(normalizar), carregado: true });
    } catch {
      if (request === requestId) {
        set({ erro: 'Não foi possível carregar empresas.' });
        notify.error('Erro ao buscar empregadores.');
      }
    } finally {
      if (request === requestId) set({ carregando: false });
    }
  },
  reset() {
    requestId += 1;
    set({ lista: [], carregando: false, carregado: false, erro: null });
  },
}));
